import clsx from 'clsx'
import React from 'react'

import * as classes from './StoriesBarSegment.classes'

type Props = {
  isLoading?: boolean
  isLoaded?: boolean
  onClick?: VoidFunction
}

export const StoriesBarSegment: React.FC<Props> = ({isLoading, isLoaded, onClick}) => {
  return (
    <div className={classes.root} onClick={onClick}>
      <div className={clsx(classes.inner, isLoading && classes.loading, isLoaded && classes.loaded)} />
    </div>
  )
}
